var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from './base.service';
import { AuthorizationService } from '../authorization.service';
import { MessageService } from '../message.service';
import { CacheService } from '../cache.service';
import { HttpClient } from '@angular/common/http';
import { DateHelper } from '../../utils/date-helper';
import { Constants } from '../../models/constants.model';
import { StatusId } from '../../models/status-id';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../language.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../authorization.service";
import * as i3 from "../message.service";
import * as i4 from "../cache.service";
import * as i5 from "../language.service";
import * as i6 from "@ngx-translate/core";
var DeviceService = /** @class */ (function (_super) {
    __extends(DeviceService, _super);
    function DeviceService(http, authorization, messages, cache, language, translation) {
        var _this = _super.call(this, http, authorization, messages, cache) || this;
        _this.language = language;
        _this.translation = translation;
        _this.endpointUri = 'RoomReservation/Devices';
        return _this;
    }
    DeviceService.prototype.getAll = function () {
        throw new Error('Method not implemented.');
    };
    DeviceService.prototype.get = function (id) {
        return this.getRequest(id);
    };
    DeviceService.prototype.add = function (entity, headers) {
        throw new Error('Method not implemented.');
    };
    DeviceService.prototype.update = function (entity) {
        throw new Error('Method not implemented.');
    };
    DeviceService.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    DeviceService.prototype.getAvailableDevices = function (params) {
        return this.getRequest(null, this.endpointUri + '/Available', this.mapAvailableDevicesParams(params));
    };
    DeviceService.prototype.getOccupanciesById = function (roomId, dateFrom, dateTo) {
        return this.getRequest(null, this.endpointUri + '/' + String(roomId) + '/Occupancies', [
            { key: 'dateFrom', value: String(DateHelper.getUnixTime(dateFrom)) },
            { key: 'dateTo', value: String(DateHelper.getUnixTime(dateTo)) }
        ]);
    };
    /**
    * Map search-params from IAvailableDevicesParams
    *
    * @private
    * @param {IAvailableDevicesParams} params
    * @returns {IKeyValuePair[]}
    * @memberof DeviceService
    */
    DeviceService.prototype.mapAvailableDevicesParams = function (params) {
        return [
            { key: nameof('idDevice'), value: params.idDevice.join(',') },
            { key: nameof('availableFrom'), value: String(DateHelper.getUnixTime(params.availableFrom)) },
            { key: nameof('availableTo'), value: String(DateHelper.getUnixTime(params.availableTo)) },
            { key: nameof('availableOnly'), value: params.availableOnly ? '1' : null },
            { key: 'designations', value: params.ressourceNumber.join(',') },
            { key: nameof('timespan'), value: params.timespan ? String(params.timespan * 60) : '' }
        ];
    };
    /**
     * Returns the first warning if the AvailableDevice ca not be reserved
     *
     * @param {AvailableDevice} device
     * @param {Date} searchDate
     * @returns {string}
     * @memberof DeviceService
     */
    DeviceService.prototype.getFirstWarning = function (device, searchDate) {
        // todo tosc: do all this messages exist?
        // status
        switch (device.StatusId) {
            case StatusId.rrGesperrt:
                return this.translation.get('DEVICE_STATE_CLOSED');
            case StatusId.rrGesperrtBis:
                if (device.StatusDate > searchDate) {
                    return this.translation.get('DEVICE_STATE_CLOSED_UNTIL', { date: this.language.formatDate(device.StatusDate) });
                }
                break;
            case StatusId.rrReservierbarBis:
                if (device.StatusDate < searchDate) {
                    return this.translation.get('DEVICE_STATE_OPEN_UNTIL', { date: this.language.formatDate(device.StatusDate) });
                }
                break;
            case StatusId.rrReservierbar: // ok
                break;
            default:
                console.warn("status unknown: (" + device.StatusId + " - " + device.Status + ")");
                break;
        }
        // c)	hat das Attribut «Belegung erlaubt» inaktiviert:
        if (!device.StatusAllowOccupation) {
            return this.translation.get('DEVICE_STATE_CLOSED');
        }
        // reservationstyp
        switch (device.ReservationRightId) {
            case Constants.ReservationsRecht.Reservable:
                // ok
                break;
            case Constants.ReservationsRecht.ProvReservable:
                return this.translation.get('DEVICE_PERMISSION_PROV');
            case Constants.ReservationsRecht.Requestable:
                return this.translation.get('DEVICE_PERMISSION_REQUEST');
            case Constants.ReservationsRecht.Visible:
            case Constants.ReservationsRecht.None:
                return this.translation.get('DEVICE_NO_PERMISSION_OCCUPY');
            default:
                console.log(device);
                throw Error('invalid reservation type: ' + device.ReservationRightId);
        }
        // keine Arbeitszeit
        if (!device.IsWorkingDay) {
            return this.translation.get('DEVICE_STATE_NO_WORKDAY', { date: this.language.formatDate(searchDate) });
        }
        return null;
    };
    DeviceService.ngInjectableDef = i0.defineInjectable({ factory: function DeviceService_Factory() { return new DeviceService(i0.inject(i1.HttpClient), i0.inject(i2.AuthorizationService), i0.inject(i3.MessageService), i0.inject(i4.CacheService), i0.inject(i5.LanguageService), i0.inject(i6.TranslateService)); }, token: DeviceService, providedIn: "root" });
    return DeviceService;
}(BaseService));
export { DeviceService };
